import { StoryblokComponent } from '@storyblok/react'
import { type FC } from 'react'
import Link from 'next/link'
import { type RichTextProps } from '../RichText/RichText.interface'
import styles from './ConfirmSignUp.module.scss'
import { RichText } from '../RichText/RichText'
import { Button } from '../Button/Button'
import { Icon } from '../Icon/Icon'

export interface ConfirmSignUpProps {
  title: string;
  text: RichTextProps;
  confirmationTitle: string;
  confirmationText: RichTextProps;
  linkText: string;
}

export const ConfirmSignUp: FC<ConfirmSignUpProps> = ({
  title,
  text,
  confirmationText,
  confirmationTitle,
  linkText
}) => (
  <main className={styles.grid}>
    <StoryblokComponent
      blok={{
        title,
        text: text.richtext,
        component: 'homepageHero'
      }}
    />
    <div>
      <h2 className={styles.title}>{confirmationTitle}</h2>
      <RichText className={styles.richtext} richtext={confirmationText.richtext} />
      <Link href="/">
        <Button round className={styles.button}>
          {linkText}
          <Icon name="#search" className={styles.icon} />
        </Button>
      </Link>

    </div>
  </main>
)
